const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;

export const validateFileExtension = (file: File): boolean => allowedExtensions.test(file.name);

export function encodeImageToBase64(image: File, setEncodedImage: Function): void {
  const fileReader = new FileReader();
  fileReader.onloadend = () => setEncodedImage(fileReader.result);
  fileReader.readAsDataURL(image);
}
